import React from 'react'
import { Stack, Dialog, DialogContent, CircularProgress } from '@mui/material'
import { useGlobalState } from 'state'

export const LoadingDialog = () => {
  const state = useGlobalState()
  return (
    <Dialog open={state.app.loading}>
      <DialogContent>
        <Stack direction={'column'} alignItems={'center'} spacing={1}>
          <CircularProgress />
          Loading...
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
